import { useTranslation } from "react-i18next";

import { IArticlesTableContent } from "../../../../@types/Articles";
import { TableSkeleton } from "../../../../components/TableSkeleton";
import { TableSorted } from "../../../../components/TableSorted";
import { CARE_INFO_SORTING_STATE } from "../../../../constants/localStorageKeys";
import { articlesListColumns } from "./articlesListColumns";

type ArticlesTableProps = {
  content: IArticlesTableContent[];
  isLoading?: boolean;
  onRowClick(rowContent: IArticlesTableContent): void;
};

export function ArticlesTable({
  content,
  isLoading = false,
  onRowClick,
}: ArticlesTableProps) {
  const { t } = useTranslation();

  if (isLoading) {
    return <TableSkeleton columnsNumber={6} rowsNumber={6} />;
  }

  return (
    <TableSorted
      data={content}
      emptyStateText={t("careInfo_emptyState")}
      columns={articlesListColumns}
      sortingStateKey={CARE_INFO_SORTING_STATE}
      onRowClick={onRowClick}
    />
  );
}
